enum CompanyIndustryType {
    AdTechAdNetwork = "adtech and adnetwork",
    ConsultingMarketResearch = "consulting and market research",
    B2BSoftware = "b2b software",
    Payments = "payments",
    LogisticsAndShipping = "logistics and shipping",
    Agency = "agency",
    PrivateEquityAndVentureCapital = "private equity and venture capital",
    Investors = "investors",
    Other = "other",
    FroTrial = "fro trial",
}

export default CompanyIndustryType;
